import axios from 'axios';
import mediaTypesAPI from '@/api/artist/media-types';
import * as templatesApi from '@/api/artist/templates.js';
// import Vue from 'vue';

const state = {
  // from query string in url (camelCase)
  query: {
  },
  filters: {
  },
  querys: {
    q: '',
    sort: '',
    page: 1,
    per_page: 5,
    type: '',
  },
  filtersList: [
    'media_type',
    'per_page',
  ],

  allMediaTypes: [],

  templates: [],

  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 20,
  },

  // preferences: {
  //   pagination: {
  //     perPage: 20,
  //   },
  // },

  cancelTokens: {},
};

const getters = {
  querys: state => state.querys,
  keyword: state => _.get(state.query, 'q'),

  filtersList: state => state.filtersList,
  hasSelectedFilters: state => _.size(_.omitBy(state.filters, _.isNil)) > 0,

  templates: state => state.templates,

  preferences: state => state.preferences,

  totalCount: state => state.pagination.totalCount,
  currentPage: state => state.pagination.currentPage,
  perPage: state => state.pagination.perPage,
};

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

// function updateListState(state, updateRow) {
//   if (!updateRow.status) return;

//   if (state.collections && state.collections.length) {
//     const index = state.collections.findIndex(x => x.id === updateRow.id);
//     Vue.set(state.collections, index, { ...state.collections[index], ...updateRow });
//   }
// }

const actions = {
  async listPriceTemplates({ commit }, params) {
    console.log('listPriceTemplates actions', params);

    const cancelToken = refreshCancelToken(state, 'listPriceTemplates');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };

    return templatesApi.listPriceTemplates(params, axiosConfig)
      .then((response) => {
        console.log('listPriceTemplates actions', params);

        commit('setTemplates', response.data.data);
        commit('setPagination', response.data);
        return response;
      });
  },

  async deletePriceTemplate({ commit, state }, templateId) {
    console.log('deletePriceTemplate action', templateId);
    if (!templateId) return;

    // optimistically remove it from list
    commit('setTemplates', state.templates.filter(x => !templateId.includes(x.id)));

    return templatesApi.deleteTemplate(templateId)
      .then((response) => {
        console.log('deletePriceTemplate deleted', response);
        return response;
      });
  },

  async getAllMediaTypes({ commit }, type) {
    const response = await mediaTypesAPI.all({ 'fields[media_type]': type });
    commit('setMediaTypes', response.data.data);
  },

  setQuery({ commit }, query) {
    console.log('setQuery actions', query);

    const filters = {};

    if (query.mediaType) {
      filters.mediaType = query.mediaType;
    }

    commit('setFilters', filters);
    commit('setQuery', query);
  },

  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },

  setCurrentPage({ commit }, number) {
    commit('setCurrentPage', number);
  },

  // getPreferences({ commit }) {
  //   if (typeof (Storage) !== 'undefined') {
  //     // test using sessionStorage first
  //     const json = sessionStorage.getItem('artist.elements.table.preferences.columns');
  //     // check for json before parsing to avoid error
  //     if (json) {
  //       const columns = JSON.parse(json);
  //       // console.log('getPreferences', preference);
  //       commit('setPreferences', {
  //         columns: columns,
  //       });
  //     }
  //   }
  // },

  // setPreferences({ commit }, preferences) {
  //   commit('setPreferences', preferences);
  // },

};

const mutations = {
  setTemplates(state, list) {
    state.templates = list;
  },

  setMediaTypes(state, mediaTypes) {
    state.allMediaTypes = mediaTypes;
  },

  setQuery(state, query) {
    console.log('setQuery mutations', query);
    state.query = query;
  },

  setFilters(state, filters) {
    console.log('setFilters mutations', filters);
    state.filters = filters;
  },

  setElements(state, data) {
    state.elements = data;
  },

  setCurrentMediaType(state, mediaType) {
    state.currentMediaType = mediaType;
  },

  // pagination
  setCurrentPage(state, number) {
    state.pagination.currentPage = parseInt(number, 10);
  },

  setPerPage(state, number) {
    state.pagination.perPage = parseInt(number, 10);
  },

  setPagination(state, data) {
    state.pagination.currentPage = data.page;
    state.pagination.perPage = data.perPage;
    state.pagination.totalCount = data.totalCount;
  },

  // setPreferences(state, preferences) {
  //   if (typeof (Storage) !== 'undefined') {
  //     // localStorage.removeItem('preference');

  //     if (_.has(preferences, 'columns')) {
  //       // test using sessionStorage first
  //       sessionStorage.setItem('artist.template.list.preferences', JSON.stringify(preferences));
  //     }
  //   }

  //   const updatePreferences = { ...state.tablePreferences, ...preferences };

  //   console.log('setPreferences', updatePreferences);
  //   state.tablePreferences = updatePreferences;
  // },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
